/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from "react";
import { addSeminar, editSeminar } from "../../apis/admin/seminar";
import useForm from "../../hooks/useForm";
import { isEmpty } from "../../utils/lodashExtend";
import { toast } from "../../utils/toast";
import Form from "../Form";
import Modal, { ModalHeader } from "../Modal";


/**
 * 기본 환불정책 불러오기 필요
 */

const defaultForm = {
  title: "",
  content: "",
  price: "0",
  lecturer: "",
  isSessionDuplicateParticipation: "true",
  isRecruitmentDuplicateParticipation: "true",
  maxPeople: "0",
  refundPolicy: "",
  topic: "",
  target: "",
  slogan: "",
};

const Seminar = (props) => {
  const { open, setOpen, submit, selectedItem, setSelectedItem } = props;
  const [fields, setFields] = useState([]);
  const [mode, setMode] = useState("create");
  const [content, setContent] = useState({});

  const cancel = (e) => {
    if (e) {
      e.preventDefault();
    }
    setOpen(false);
    setForm(defaultForm);
    submit && submit();
    if (setSelectedItem) {
      setSelectedItem(null);
    }
  };

  const _submit = (form) => {
    const data = {
      ...form,
      content: (form.content || "").replace(/\n/g, "<br/>"),
      thumbnailIdx: !isEmpty(form.thumbnailFile) ? form.thumbnailFile[form.thumbnailFile.length - 1] : null
    };

    if (mode === "create") {
      addSeminar(data).then(() => {
        toast.success("등록이 완료되었습니다.");
        cancel();
      });
    } else {
      editSeminar(data, form.idx).then(res => {
        toast.success("수정이 완료되었습니다.");
        cancel();
      });
    }
  };

  const {
    form,
    setForm,
    errors,
    handleOnChange,
    handleSubmit,
    setValidateFields,
    setOriginForm,
  } = useForm(
    defaultForm,
    _submit,
  );

  const _submitFields = () => {
    setFields([
      [
        {
          key: "title",
          title: "제목",
          type: "input",
          required: true,
        },
        {
          key: "topic",
          title: "주제",
          type: "input",
        },
      ],
      [
        {
          key: "slogan",
          title: "슬로건",
          type: "input",
        }
      ],
      [
        {
          title: "강연자",
          type: "input",
          key: "lecturer"
        },
        {
          key: "target",
          title: "대상",
          type: "input",
        },
      ],
      [
        {
          title: "최대인원",
          key: "maxPeople",
          type: "number",
        },
        {
          title: "금액",
          key: "price",
          type: "input",
          validators: ['comma'],
        },
      ],
      [
        {
          title: "썸네일",
          type: "file-upload",
          key: "thumbnailFile",
          required: false,
          isAdmin: true
        },
      ],
      [

        {
          title: "세미나 내 시즌 중복 신청 여부",
          key: "isSessionDuplicateParticipation",
          type: "radio",
          options: {
            list: [{ label: "가능", value: "true" }, { label: "불가능", value: "false" }]
          },
        },
        {
          title: "세미나 회차 내 모집 중복 신청 여부",
          key: "isRecruitmentDuplicateParticipation",
          type: "radio",
          options: {
            list: [{ label: "가능", value: "true" }, { label: "불가능", value: "false" }]
          },
        },
      ],
      [
        {
          title: "내용",
          key: "content",
          type: "editor",
          required: true,
          onChange: (e) => {
            setContent(e);
          }
        },
      ],
      // [
      //   {
      //     title: "환불정책",
      //     key: "refundPolicy",
      //     type: "editor",
      //     required: true,
      //   },
      // ],
    ]);
  };

  useEffect(() => {
    _submitFields();
  }, [mode]);

  useEffect(() => {
    if (!isEmpty(fields)) setValidateFields(fields);
  }, [fields]);

  useEffect(() => {
    !isEmpty(content) && handleOnChange(content);
  }, [content]);

  useEffect(() => {
    setValidateFields(fields);
    setMode(selectedItem ? 'detail' : 'create');
    if (selectedItem) {
      setForm(setData(selectedItem));
      setOriginForm(selectedItem);
    } else {
      setForm(defaultForm);
      setOriginForm(defaultForm);
    }
  }, [open, selectedItem]);


  const setData = (data) => {
    const thumbnailFile = !isEmpty(data.thumbnailFile) ? [data.thumbnailFile] : null;
    return {
      ...data,
      thumbnailFile
    };
  };
  return (
    <>
      <Modal
        isOpen={open}
        close={cancel}
      >
        <ModalHeader>
          {`세미나 ${mode === "create" ? "등록" : "수정"}`}
        </ModalHeader>
        <Form
          fields={fields}
          form={form}
          errors={errors}
          isRequiredShow={true}
          setForm={setForm}
          onChange={handleOnChange}
          submitText={mode === "create" ? "등록" : "수정"}
          submit={handleSubmit}
        />
      </Modal>
    </>
  );
};

export default Seminar;